export class MediaDeviceList {
    devices;
    devicesFingerprint;
    constructor() {
        this.devices = [];
    }
    getDevices() {
        return this.devices;
    }
    static createDevicesFingerprint(devices) {
        return JSON.stringify(devices
            .map((device) => `${device.kind}:${device.deviceId}`)
            .sort((a, b) => a.localeCompare(b)));
    }
    // @return true if the devices have changed
    updateDevices(mediaDevices) {
        const newDevicesFingerprint = MediaDeviceList.createDevicesFingerprint(mediaDevices);
        if (newDevicesFingerprint === this.devicesFingerprint) {
            return false;
        }
        this.devicesFingerprint = newDevicesFingerprint;
        this.devices = mediaDevices;
        return true;
    }
    has(device) {
        return this.devices.some((d) => d.deviceId === device.deviceId);
    }
}
